module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-heizung-2477d0958f658352bc37ef9b79222a14.svg";